






































































































import Vue from 'vue'
import { DashboardServiceLink, DashboardLink } from '@/utils/interfaces'
import { getProfile } from '@/api/Auth/auth.api'
import UserCard from '@/components/Dashboard/UserCard.vue'
import DashboardAlerts from '@/components/DashboardAlerts.vue'
import TopUpNotificationDialog from '~/components/Dashboard/TopUpNotificationDialog.vue'
import { getTopUpDeals } from '~/api/Topup/topup.api'
import { TopUpDeal } from '~/utils/interfaces/topup.interface'

export default Vue.extend({
  components: {
    appTopUpCard: () => import('@/components/Dashboard/TopUpCard.vue'),
    appUserCard: UserCard,
    DashboardAlerts,
    TopUpNotificationDialog,
  },
  data() {
    return {
      deals: [] as TopUpDeal[],
      dealModel: false,
      links: [
        {
          service: 'TOP-UP',
          icon: 'mdi-telegram',
          to: { name: 'topup.list' },
          color: 'primary',
          text: this.$t('topup.topup'),
          roles: ['ADMIN', 'WHOLESALER', 'AGENT'],
        },
        {
          color: 'secondary',
          service: 'REMITTANCE',
          icon: 'mdi-currency-usd',
          to: { name: 'remittances-list' },
          text: this.$t('remittances'),
          roles: ['ADMIN', 'AGENT', 'EMPLOYEE', 'WHOLESALER'],
        },
      ] as DashboardServiceLink[],
      options: [
        {
          icon: 'mdi-account',
          to: { name: 'agency-users' },
          color: 'primary',
          text: this.$t('users'),
          roles: ['ADMIN', 'AGENT'],
        },
        // {
        //   class: 'secondary',
        //   icon: 'mdi-bank',
        //   to: { name: 'exchange-rate' },
        //   text: this.$t('exchange-rate'),
        //   roles: ['ADMIN'],
        // },
      ] as DashboardLink[],
    }
  },
  computed: {
    computedLinks(): DashboardServiceLink[] {
      return this.links.filter(
        link =>
          this.$store.getters.profile.services.includes(link.service) &&
          link.roles.includes(this.$store.getters.profile.role),
      )
    },
    computedOptions(): DashboardLink[] {
      return this.options.filter(option =>
        option.roles.includes(this.$store.getters.profile.role),
      )
    },
  },
  async mounted() {
    getTopUpDeals({
      end_date__gte: new Date().toISOString().substring(0, 10),
    }).then(response => {
      this.deals = response.data.results
      if (this.deals.length) {
        this.dealModel = true
      }
    })
    const response = await getProfile()
    this.$store.commit('UPDATE_PROFILE', response.data)
  },
})
